'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _UserPlanBadge = require('./UserPlanBadge');

var _UserPlanBadge2 = _interopRequireDefault(_UserPlanBadge);

var _userUtil = require('../../user/userUtil');

var _userHelper = require('../../../common/users/userHelper');

require('./UserName.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserName = function UserName(_ref) {
    var user = _ref.user;

    if ((0, _userHelper.isActive)(user)) {
        return _react2.default.createElement(
            'span',
            { className: 'UserName' },
            _react2.default.createElement(
                'span',
                null,
                (0, _userUtil.getDisplayName)(user)
            ),
            _react2.default.createElement(_UserPlanBadge2.default, { user: user })
        );
    }

    return _react2.default.createElement(
        'span',
        { className: 'UserName email' },
        _react2.default.createElement(
            'span',
            null,
            user.get('email')
        )
    );
};

UserName.propTypes = {
    user: _propTypes2.default.object.isRequired
};

exports.default = UserName;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/userAvatar/UserName.js
// module id = 445
// module chunks = 0